// Generated from the repo-root whats-new.json before TV tests/typecheck/builds.
// Keeping the import inside src preserves CRA/webpack's source boundary.
import { parseWhatsNewHistory } from '@streambase/config/whats-new';
import data from '../../config/whats-new.generated.json';

const whatsNew = parseWhatsNewHistory(data);

export default whatsNew;
